export const formatFractionalString = (
    val: string,
    fractionDigits: number = 2,
): string => {
    if (!val.includes('/')) return val;

    const [numerator, denominator] = val.split('/').map(Number);

    if (isNaN(numerator) || !denominator) return val;

    const result = numerator / denominator;

    return Number(result.toFixed(fractionDigits)).toString();
};
